export default "__VITE_ASSET__CSv1pjum__"